import { fetchReducerFactory } from '../../../shared/store/fetchFactory';

import {
  FETCH_BOOK_TO_TAX_DIFFERENCES,
  DELETE_BOOK_TO_TAX_DIFFERENCES,
  BATCH_UPDATE_BOOK_TO_TAX_DIFFERENCES,
  ADD_BOOK_TO_TAX_DIFFERENCES,
  FETCH_BOOK_TO_TAX_CODE_DESCRIPTIONS,
  UPLOAD_BOOK_TO_TAX_DIFFERENCE,
  IMPORT_BOOK_TO_TAX_DIFFERENCE,
  REFRESH_BOOK_TO_TAX_DIFFERENCES,
  CLEAR_UPLOADED_BOOK_TO_TAX_DIFFERENCES,
  FETCH_COUNTRIES,
  SELECT_COUNTRY,
} from './types';

import {
  FETCH_ACCOUNTS_STARTED,
  FETCH_ACCOUNTS_SUCCESS,
  FETCH_ACCOUNTS_FAILURE,
} from '../../../shared/store/types';

import initialState from './initialState';

const fetchReducer = fetchReducerFactory({
  [FETCH_BOOK_TO_TAX_DIFFERENCES]: 'BookToTaxDifferences',
  [DELETE_BOOK_TO_TAX_DIFFERENCES]: 'BookToTaxDifferenceRemove',
  [BATCH_UPDATE_BOOK_TO_TAX_DIFFERENCES]: 'BookToTaxDifferenceBatchUpdate',
  [ADD_BOOK_TO_TAX_DIFFERENCES]: 'BookToTaxDifferenceAdd',
  [FETCH_BOOK_TO_TAX_CODE_DESCRIPTIONS]: 'BookToTaxCodeDescriptions',
  [UPLOAD_BOOK_TO_TAX_DIFFERENCE]: 'UploadedBookToTaxDifferences',
  [IMPORT_BOOK_TO_TAX_DIFFERENCE]: 'BookToTaxDifferenceImport',
  [REFRESH_BOOK_TO_TAX_DIFFERENCES]: 'BookToTaxDifferenceRefresh',
  [FETCH_COUNTRIES]: 'BookToTaxDifferencesCountries',
}, initialState);

const bookToTaxDifferencesReducer = (state = initialState, action) => {
  switch (action.type) {
    case CLEAR_UPLOADED_BOOK_TO_TAX_DIFFERENCES:
      return {
        ...state,
        uploadedBookToTaxDifferences: initialState.uploadedBookToTaxDifferences,
      };
    case FETCH_ACCOUNTS_STARTED:
      return {
        ...state,
        isFetchingAccounts: true,
        accounts: initialState.accounts,
      };
    case FETCH_ACCOUNTS_SUCCESS:
      return {
        ...state,
        isFetchingAccounts: false,
        accounts: action.accounts,
      };
    case FETCH_ACCOUNTS_FAILURE:
      return {
        ...state,
        isFetchingAccounts: false,
        accounts: initialState.accounts,
      };
    case SELECT_COUNTRY:
      return {
        ...state,
        selectedCountry: {
          countryCode: action.country.value,
        },
      };
    default:
      return fetchReducer(state, action);
  }
};

export default bookToTaxDifferencesReducer;
